module.exports = __webpack_public_path__ + "static/media/truck-icon-stopped.84567791.svg";